











































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';

import DelayDialog from '@/views/inspectionContents/rectificationNotice/delayUnit/delayDialog.vue';
import FeedbackDialog from '@/views/inspectionContents/rectificationNotice/feedbackUnit/feedbackDialog.vue';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: { DelayDialog, FeedbackDialog },
})
export default class RectifyDetail extends Vue {
  @Prop(Object) row!: any; // 从父组件接受过来一行的数据
  private scrollbar = true;

  private activeName: any = ''; // 默认显示安全检查单
  private showHazardFormData: any = {}; // 激活 的隐患数据
  private btnHandleShow: any = false; // 我整改的 true / 我下发的 false
  private feedBackHazardList: any = []; // 待反馈隐患列表
  private serverUrl = publishObjectPath.imgPathWater;

  // 详情数据
  private rectifyFormInfo: any = {
    hazards: [],
  };
  private hazardStatus: any = {
    CREATED: '已创建',
    ISSUED: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
    OTHERWISE: '另行办结',
  }; // 隐患状态
  private levelText: any = {
    D: '一般隐患III级(D)',
    C: '一般隐患II级(C)',
    B: '一般隐患I级(B)',
    A: '重大隐患(A)',
  };

  private delayStatus: any = {
    1: '待审核',
    2: '已延期',
    3: '已驳回',
    4: '已取消',
  }; // 延期状态
  private delayFlag: any = false; // 延期反馈/普通反馈 标识

  cancelHazardDelay() {
    this.$confirm('确定取消延期申请吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        performanceServer.cancelHazardDelay({ applyDelayId: this.showHazardFormData.applyDelayId }).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('取消成功！');
            this.getRectifyDetail();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
  delayHazard() {
    const obj: any = {
      id: this.showHazardFormData.id,
      rectifyExpiryDate: this.showHazardFormData.rectifyExpiryDate,
      delayStatus: this.showHazardFormData.delayStatus,
      extensionDeadline: this.showHazardFormData.extensionDeadline,
    };
    (this.$refs.DelayDialogRef as any).showDialog(obj);
  }
  delayDialogRes() {
    this.getRectifyDetail();
  }

  private handleClick(tab: any, event: any) {
    this.showHazardFormData = this.rectifyFormInfo.hazards[Number(tab.index)];
  }

  created() {
    this.getRectifyDetail();
    this.btnHandleShow = this.row.type === '我整改的';
  }
  private getRectifyDetail() {
    performanceServer
      .detailRectifyForm(this.row.id)
      .then((res: any) => {
        if (res.code === '200') {
          this.rectifyFormInfo = res.data;
          if (res.data.hazards.length) {
            this.activeName = this.rectifyFormInfo.hazards[0].id;
            this.rectifyFormInfo.hazards.forEach((item: any) => {
              this.$set(item, 'hazardPictureFiles', []);
              this.$set(item, 'rectifyPictureFiles', []);
              this.$set(item, 'reviewPictureFiles', []);
              if (item.hazardPicture) {
                this.getSysFile(item, 'hazardPicture');
              }
              if (item.rectifyPicture) {
                this.getSysFile(item, 'rectifyPicture');
              }
              if (item.reviewPicture) {
                this.getSysFile(item, 'reviewPicture');
              }
            });
            this.showHazardFormData = res.data.hazards[0];
            this.feedBackHazardList = this.rectifyFormInfo.hazards.filter((item: any) => (item.status === 'ISSUED' || item.status === 'RECTIFYING' || item.status === 'RECTIFIED' || item.status === 'REVIEW_FAIL') && !item.closeFlag);
          }
        } else {
        }
      })
      .catch(() => {});
  }

  private getSysFile(data: any, type: any) {
    if (type === 'hazardPicture') {
      performanceServer.getSysFile(data.hazardPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length > 0) {
          if (type === 'hazardPicture') {
            data.hazardPictureFiles = res.data;
          }
        }
      });
    }
    if (type === 'rectifyPicture') {
      performanceServer.getSysFile(data.rectifyPicture).then((res: any) => {
        if (res.code === '200') {
          data.rectifyPictureFiles = res.data;
        }
      });
    }
    if (type === 'reviewPicture') {
      performanceServer.getSysFile(data.reviewPicture).then((res: any) => {
        if (res.code === '200') {
          data.reviewPictureFiles = res.data;
        }
      });
    }
  }
  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrl}${item.path}`);
    });
    return arr;
  }

  /**
   * 返回
   * */
  private backToIndex() {
    this.$emit('backToTableList');
  }
  /**
   * 反馈
   * */
  private feedBackClick() {
    this.delayFlag = false;
    const obj: any = {
      rectifyFormId: this.row.id,
      delayFlag: false,
      feedBackHazardList: [],
    };
    if (this.feedBackHazardList.some((item: any) => item.delayStatus === 1)) {
      this.$confirm('存在延期申请待审核的隐患，确定该记录走反馈流程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          obj.feedBackHazardList = this.feedBackHazardList.filter((item: any) => item.delayStatus !== 2);
          (this.$refs.FeedbackDialogRef as any).showDialog(obj);
        })
        .catch(() => {
          obj.feedBackHazardList = this.feedBackHazardList.filter((item: any) => item.delayStatus !== 1 && item.delayStatus !== 2);
          if (!obj.feedBackHazardList.length) {
            this.$message.warning('暂无需要反馈的隐患');
            return;
          }
          (this.$refs.FeedbackDialogRef as any).showDialog(obj);
        });
    } else {
      obj.feedBackHazardList = this.feedBackHazardList.filter((item: any) => item.delayStatus !== 2);
      (this.$refs.FeedbackDialogRef as any).showDialog(obj);
    }
  }
  /**
   * 延期反馈
   * */
  private delayFeedBackClick() {
    const obj: any = {
      rectifyFormId: this.row.id,
      delayFlag: true,
      feedBackHazardList: this.feedBackHazardList.filter((item: any) => item.delayStatus === 2),
    };
    (this.$refs.FeedbackDialogRef as any).showDialog(obj);
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }
}
